__turbopack_context__.v({
  "shimmer": "fmTa4a_shimmer",
});
